<template>
  <div class="tree-select-control-search">
    <SearchInput
      :value="value"
      class="tree-select-control-search__input"
      :icon="iconSearch"
      :emit-input-on-change="false"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
  import iconSearch from 'assets/icons/search.svg';
  import SearchInput from 'utils/search/SearchInput';

  export default {
    name: 'TreeSelectControlSearch',
    components: {SearchInput},
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        iconSearch
      };
    }
  };
</script>

<style>
  .tree-select-control-search__input .m-input__field {
    height: 28px;
    border-radius: 0;
  }

  .tree-select-control-search__input .m-input__icon {
    color: var(--secondary-text-color);
    padding: 0;
  }
</style>
